var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
var BUTTON_VARIANTS = {
    primary: 'px-[30px] py-[11px] shadow-sm text-white bg-primary enabled:hover:bg-primary/90',
    secondary: 'text-primary px-[13px] py-[6px] group-hover:bg-primary',
    // outline:
    // 'esm:px-4 px-2 shadow-sm text-primary bg-white-flash enabled:hover:bg-white-flash/70 border border-primary',
    // delete: 'esm:px-4 px-2 shadow-sm text-error bg-linen enabled:hover:bg-linen/70 border border-error',
    // neutral: 'text-primary bg-none enabled:hover:text-primary',
    inactive: 'text-button-text-dark bg-none enabled:hover:text-blue-pantone border border-gray-spanish',
    active: 'text-primary bg-none enabled:hover:text-blue-pantone border border-primary',
    // empty: 'text-primary bg-none',
};
export var Button = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.buttonIcon, buttonIcon = _c === void 0 ? false : _c, rest = __rest(_a, ["children", "className", "variant", "buttonIcon"]);
    var buttonContent = children;
    return (_jsx("button", __assign({ disabled: rest.disabled, className: twMerge("flex-center text-semibold gap-1 whitespace-nowrap rounded-lg font-sans text-[14px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:opacity-50", BUTTON_VARIANTS[variant], !buttonIcon ? 'py-1.5' : 'px-0', className) }, rest, { children: buttonContent })));
};
